import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";

import Rendertable from "./Rendertable";
import { getProductSearchResultforsales, downloadAllProductExcel } from "../../../actions/productDetails";
import { getAllLocation, getAllTransferLocation } from "../../../actions/warehouseAction";
import Excelldownload from "./Excelldownload";
import ReactToPrint from "react-to-print";

import {
  Divider,
  AutoComplete,
  Row,
  Col,
  Select,
  Skeleton,
  Button,
  Spin,
} from "antd";
const { Option } = Select;

const SearchStock = ({
  getProductSearchResultforsales,
  getAllLocation,
  getAllTransferLocation,
  businessprofile,
}) => {
  var formatter = new Intl.NumberFormat("en-IN");
  const componentRef = useRef();
  const [List, setList] = useState([]);
  const [data, setData] = useState([]);
  const [allDataForPDF, setAllDataForPDF] = useState([]);
  const [locations, setLocations] = useState([]);
  const [loading, setloading] = useState(true);
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [reload, setreload] = useState(false);
  const location = useRef("");
  const keyward = useRef("");
  const pageno = useRef(1);
  const page_size = useRef(10);
  let total_data = useRef({});
  const printButtonRef = useRef();

  const onChange = (event) => {
    if (event.keyCode == 13) {
      keyward.current = event.target.value;
      setreload(!reload);
    }
  };

  useEffect(() => {
    getAllTransferLocation().then((result) => {
      setLocations(result);
    });
    getProductSearchResultforsales(
      keyward.current,
      location.current,
      pageno.current,
      page_size.current
    ).then((result) => {
      total_data.current = {
        total_purchase_price: result.total_purchase_price,
        total_selling_price: result.total_selling_price,
        total_quantity: result.total_quantity,
        current_purchase_price: result.current_purchase_price,
        current_selling_price: result.current_selling_price,
        current_quantity: result.current_quantity,
      };
      setList(result);
      setData(result.results);
      setloading(false);
    });
  }, [reload]);

  const renderdata = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return (
        <Rendertable
          List={List}
          pageno={pageno}
          page_size={page_size}
          setreload={setreload}
          reload={reload}
          setloading={setloading}
          total_data={total_data}
        />
      );
    }
  };

  const handleDownloadAll = async () => {
    await downloadAllProductExcel(
      keyward.current,
      location.current
    );
  };

  // Fetch all data for PDF
  const fetchAllDataForPDF = async () => {
    setLoadingPDF(true);
    try {
      // Fetch with a very large page size to get all data
      const result = await getProductSearchResultforsales(
        keyward.current,
        location.current,
        1, // page number
        10000 // large page size to get all records
      );
      
      setAllDataForPDF(result.results);
      
      // Update total data for PDF
      total_data.current = {
        total_purchase_price: result.total_purchase_price,
        total_selling_price: result.total_selling_price,
        total_quantity: result.total_quantity,
        current_purchase_price: result.current_purchase_price,
        current_selling_price: result.current_selling_price,
        current_quantity: result.current_quantity,
      };
      
      setLoadingPDF(false);
      
      // Trigger print after data is loaded
      setTimeout(() => {
        if (printButtonRef.current) {
          printButtonRef.current.click();
        }
      }, 100);
    } catch (error) {
      console.error("Failed to fetch data for PDF:", error);
      setLoadingPDF(false);
      alert("Failed to load data for PDF");
    }
  };

  return (
    <>
      <Row>
        <Col span={6}>
          <h3>Product Search</h3>
          <AutoComplete
            placeholder="input search text"
            onKeyUp={onChange}
            style={{ width: "100%" }}
          />
        </Col>
        <Col span={5} offset={1}>
          <h3>Choose warehouse / outlet</h3>
          <Select
            placeholder="Please select a outlet / warehouse"
            style={{ width: "100%" }}
            onChange={(e) => {
              location.current = e;
              setloading(true);
              setreload(!reload);
            }}
          >
            <Option value="">All</Option>
            {locations.map((outlet) => {
              return <Option key={outlet.id} value={outlet.id}>{outlet.name}</Option>;
            })}
          </Select>
        </Col>
        <Col span={4} offset={1}>
          <h3>Export</h3>
          <Excelldownload data={data} />
        </Col>
        <Col span={3} offset={0}>
          <h3>Download All</h3>
          <Button
            type="primary"
            style={{ backgroundColor: "red" }}
            onClick={handleDownloadAll}
          >
            Excel Report
          </Button>
        </Col>
        <Col span={2}>
          <h3>PDF</h3>
          <Spin spinning={loadingPDF}>
            <Button 
              type="primary" 
              onClick={fetchAllDataForPDF}
              disabled={loadingPDF}
            >
              {loadingPDF ? "Loading..." : "Print All"}
            </Button>
          </Spin>
          
          {/* Hidden ReactToPrint button */}
          <div style={{ display: "none" }}>
            <ReactToPrint
              trigger={() => <button ref={printButtonRef}>Print</button>}
              content={() => componentRef.current}
              onAfterPrint={() => setAllDataForPDF([])}
            />
          </div>

          {/* Print Content */}
          <div style={{ display: "none" }}>
            <div
              className="invoice_print_fontSize"
              ref={componentRef}
              style={{ padding: "10px" }}
            >
              <Row
                style={{
                  borderBottom: "2px solid lightgray",
                  paddingBottom: "5px",
                  marginBottom: "20px",
                }}
              >
                <Col span={17} style={{ paddingTop: "10px" }}>
                  <small>
                    <div
                      style={{ lineHeight: "2.5px" }}
                      dangerouslySetInnerHTML={{
                        __html: businessprofile.address,
                      }}
                    ></div>
                  </small>
                </Col>

                <Col span={7} style={{ textAlign: "right" }}>
                  <img
                    src={businessprofile.logo}
                    alt="Logo"
                    style={{
                      maxHeight: "60px",
                    }}
                  />
                </Col>
              </Row>

              <h3 style={{ textAlign: "center" }}>Stock Report (All Data)</h3>
              <Row>
                <Col span={12} style={{ textAlign: "left", lineHeight: "1.6" }}>
                  <div><strong>Total Quantity:</strong> {formatter.format(total_data.current["total_quantity"])}</div>
                  <div><strong>Total Purchase Price:</strong> {formatter.format(total_data.current["total_purchase_price"])}</div>
                  <div><strong>Total Selling Price:</strong> {formatter.format(total_data.current["total_selling_price"])}</div>
                </Col>
                <Col span={12} style={{ textAlign: "right" }}>
                  {locations.map((outlet) => {
                    if (outlet.id == location.current)
                      return <span key={outlet.id}>Outlet: {outlet.name}</span>;
                  })}
                </Col>
              </Row>
              
              <table className="product_table invoice_print_fontSize">
                <thead>
                  <tr>
                    <th>SL.</th>
                    <th>Barcode</th>
                    <th>Product</th>
                    <th>Category</th>
                    <th>Color</th>
                    <th>Size</th>
                    <th>Warehouse</th>
                    <th>Quantity</th>
                    <th>Manufacturing Cost</th>
                    <th>Selling Price</th>
                  </tr>
                </thead>
                <tbody>
                  {(allDataForPDF.length > 0 ? allDataForPDF : data).map((item, index) => {
                    return (
                      <tr key={item.id || index}>
                        <td>{index + 1}</td>
                        <td>{item.barcode}</td>
                        <td>{item.title}</td>
                        <td>{item.category}</td>
                        <td>{item.color}</td>
                        <td>{item.size}</td>
                        <td>{item.Warehouse_name}</td>
                        <td>{item.quantity}</td>
                        <td>{formatter.format(item.purchase_price)}</td>
                        <td>{formatter.format(item.selling_price)}</td>
                      </tr>
                    );
                  })}
                  <tr>
                    <td colSpan={7}><strong>Total:</strong></td>
                    <td><strong>{formatter.format(total_data.current["total_quantity"])}</strong></td>
                    <td><strong>{formatter.format(total_data.current["total_purchase_price"])}</strong></td>
                    <td><strong>{formatter.format(total_data.current["total_selling_price"])}</strong></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Divider />
        <Col span={20}>
          <table style={{ width: "20%" }}>
            <tbody>
              <tr>
                <td>
                  <b>Total Quantity:</b>
                </td>
                <td style={{ textAlign: "right" }}>
                  {formatter.format(total_data.current["total_quantity"])}
                </td>
              </tr>
              <tr>
                <td>
                  <b>Total Price:</b>
                </td>
                <td style={{ textAlign: "right" }}>
                  {formatter.format(total_data.current["total_selling_price"])}
                </td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>

      <Divider />
      {renderdata()}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    businessprofile: state.settings.businessprofile,
  };
};

export default connect(mapStateToProps, {
  getProductSearchResultforsales,
  getAllLocation,
  getAllTransferLocation,
})(SearchStock);